import { useTimezone } from '@/components/contexts/TimezoneContext';
import { Card } from '@/components/ui/card';
import { useHomeDeadlines } from '@/hooks/useHomeDeadlines';
import { DeadlineWeekTabs } from '@/pages/home/deadline-widgets/DeadlineWeekTabs';
import { useExploreDeadlines, useHomeWeekStartsOn } from '@/pages/home/deadline-widgets/shared';

type DeadlinesPanelProps = {
  matterRegion?: string | null;
};

export function DeadlinesPanel({ matterRegion }: DeadlinesPanelProps) {
  const { timezone } = useTimezone();
  const weekStartsOn = useHomeWeekStartsOn(matterRegion);
  const { deadlines, isLoading, isError, mutate } = useHomeDeadlines({
    timezone,
    weekStartsOn,
    enabled: true,
  });
  const { weeks, openDeadline } = useExploreDeadlines({
    deadlines,
    matterRegion,
    timezone,
  });

  return (
    <Card flat className="flex h-full min-h-0 w-full flex-col px-6">
      <div className="mb-3 py-4">
        <h2 className="text-sm font-semibold tracking-tight text-slate-700">
          Upcoming deadlines
        </h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Confirmed deadlines across your matters for the next four weeks
        </p>
      </div>
      <DeadlineWeekTabs
        weeks={weeks}
        openDeadline={openDeadline}
        isLoading={isLoading}
        isError={Boolean(isError)}
        onRetry={() => void mutate()}
        idBase="all-matters-deadline-weeks"
        className="flex min-h-0 flex-1 flex-col"
        listClassName="mt-3 max-h-[min(70vh,40rem)] overflow-y-auto"
        emptyClassName="py-10 text-center text-sm text-slate-400"
      />
    </Card>
  );
}
